import {
    FETCH_SERVICE_GROUP_CONFIGURATION,
    FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS,
} from '../actions/types';

const initialState = {
    catalogs: { service_groups: [], service_conditions: [], product_groups: [] },
    configuration: { service_group_conditions: [], materials: [] },
};

export default function serviceGroupConfigurationReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS:
            return { ...state, catalogs: action.payload || initialState.catalogs };
        case FETCH_SERVICE_GROUP_CONFIGURATION:
            return { ...state, configuration: action.payload || initialState.configuration };
        default:
            return state;
    }
}
